export default "<span *ngIf=\"msg.length > 145\" matTooltip=\"{{ msg }}\">{{ msg }}</span>\n<span *ngIf=\"msg.length <= 145\">{{ msg }}</span>\n"